"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshAllSpells = exports.getSpellStats = exports.resetSpellData = exports.get = void 0;
var rogueSpellConeOfWater_sidecar_1 = require("./rogueSpellConeOfWater-sidecar");
var rogueSpellFireball_sidecar_1 = require("./rogueSpellFireball-sidecar");
var rogueSpellTeleport_sidecar_1 = require("./rogueSpellTeleport-sidecar");
var rogueSpellWaterball_sidecar_1 = require("./rogueSpellWaterball-sidecar");
var rogueSpellWaterBlast_sidecar_1 = require("./rogueSpellWaterBlast-sidecar");
var rogueSpellWaterbolt_sidecar_1 = require("./rogueSpellWaterbolt-sidecar");
var rogueSpell_iceArmor_sidecar_1 = require("./rogueSpell_iceArmor-sidecar");
var rogueSpell_kineticRock_sidecar_1 = require("./rogueSpell_kineticRock-sidecar");
var rogueSpell_waterHands_sidecar_1 = require("./rogueSpell_waterHands-sidecar");
var _objs = null;
var get = function () {
    if (_objs === null) {
        _objs = [];
        _objs.push(rogueSpellWaterbolt_sidecar_1.rogueSpellWaterbolt.getSpellData());
        _objs.push(rogueSpellWaterball_sidecar_1.rogueSpellWaterball.getSpellData());
        _objs.push(rogueSpellConeOfWater_sidecar_1.rogueSpellConeOfWater.getSpellData());
        _objs.push(rogueSpellWaterBlast_sidecar_1.rogueSpellWaterBlast.getSpellData());
        _objs.push(rogueSpell_kineticRock_sidecar_1.rogueSpell_kineticRock.getSpellData());
        _objs.push(rogueSpell_waterHands_sidecar_1.rogueSpell_waterHands.getSpellData());
        _objs.push(rogueSpell_iceArmor_sidecar_1.rogueSpell_iceArmor.getSpellData());
        _objs.push(rogueSpellTeleport_sidecar_1.rogueSpellTeleport.getSpellData());
        _objs.push(rogueSpellFireball_sidecar_1.rogueSpellFireball.getSpellData());
        // Non-cast spells
        // Look spell?
        (0, exports.resetSpellData)();
    }
    return _objs;
};
exports.get = get;
var resetSpellData = function () {
    var _objs = (0, exports.get)();
    _objs.forEach(function (spellData) {
        spellData.isBought = false;
        spellData.usesLeft = spellData.maxUses;
        spellData.upgrades.forEach(function (upgrade) {
            if (!upgrade.name) {
                upgrade.name = upgrade.key + ' +' + upgrade.effectAmount;
            }
            upgrade.isBought = false;
        });
    });
};
exports.resetSpellData = resetSpellData;
var getSpellStats = function (key) {
    var _objs = (0, exports.get)();
    var spellData = _objs.find(function (spellData) { return spellData.key === key; });
    if (!spellData) {
        throw new Error('Spell data not found for key: ' + key);
    }
    var spellStats = {
        key: spellData.key,
        damage: spellData.baseDamage,
        range: spellData.baseRange,
        radius: spellData.baseRadius,
        numUses: spellData.usesLeft,
        maxUses: spellData.maxUses,
        duration: spellData.duration,
        name: '',
        statsString: '',
        baseSpell: spellData,
        protection: spellData.baseProtection || 0,
    };
    spellData.upgrades.forEach(function (upgrade) {
        if (upgrade.isBought) {
            if (upgrade.key === 'range') {
                spellStats.range += upgrade.effectAmount;
            }
            if (upgrade.key === 'radius') {
                spellStats.radius += upgrade.effectAmount;
            }
            if (upgrade.key === 'max-uses') {
                spellStats.maxUses += upgrade.effectAmount;
            }
            if (upgrade.key === 'duration') {
                spellStats.duration += upgrade.effectAmount;
            }
            if (upgrade.key === 'protection') {
                spellStats.protection += upgrade.effectAmount;
            }
        }
    });
    if (!spellData.isBought) {
        spellStats.name += spellData.cost + ' sp ';
    }
    spellStats.name += spellData.name;
    spellStats.name += " ".concat(spellStats.numUses, "/").concat(spellStats.maxUses, " ");
    if (spellStats.duration) {
        spellStats.statsString += " Turns".concat(spellStats.duration);
    }
    if (spellStats.radius > 1) {
        spellStats.statsString += " Radius".concat(spellStats.radius);
    }
    if (spellStats.range > 1) {
        spellStats.statsString += " Range".concat(spellStats.range);
    }
    if (spellStats.damage > 1) {
        spellStats.statsString += " Damage".concat(spellStats.damage);
    }
    spellStats.statsString += ' MaxUses' + spellStats.maxUses;
    return spellStats;
};
exports.getSpellStats = getSpellStats;
var refreshAllSpells = function () {
    var sd = (0, exports.get)();
    sd.forEach(function (spellData) {
        var ss = (0, exports.getSpellStats)(spellData.key);
        spellData.usesLeft = ss.maxUses;
    });
};
exports.refreshAllSpells = refreshAllSpells;
